import React, { useEffect } from "react";
import { Button, Form, FormInstance, Input, Space } from "antd";
import "./sp_bank.css";
import { DataTypeBank } from "../../components/hoc_supplier_master";

interface SpBankProps {
    onCancel?: () => void;
    onSubmit?: (values: any) => void;
    initialData?: DataTypeBank | null;
    isEditMode?: boolean;
}

const SpBank: React.FC<SpBankProps> = ({
    onCancel,
    onSubmit,
    initialData,
    isEditMode
}) => {

    const [form] = Form.useForm<DataTypeBank>(); 
    useEffect(() => {
        if (isEditMode && initialData) {
            
            form.setFieldsValue(initialData);
            console.log("SpBank: Form populated with initial data for edit:", initialData);
        } else {   
            form.resetFields();
            console.log("SpBank: Form reset for add mode.");
        }
    }, [isEditMode, initialData, form]); 
    
    const handleFormSubmit = (values: any) => {
        console.log("Bank form submitted with values:", values);
        if (onSubmit) {
            onSubmit(values); 
        } else {
            console.error("onSubmit prop is missing in SpBank!"); 
        }
        form.resetFields();
    };
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    return (

        <div id="iau9" style={transformStyle}>
            <div className="gjs-grid-row" id="i21th">
                <div className="gjs-grid-column" id="ictds">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        onFinish={handleFormSubmit}
                    >
                        <Form.Item
                            label="Bank Name"
                            name="bank_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Acc Type"
                            name="acc_type"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Account No"
                            name="account_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Name"
                            name="name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item>
                            <Space
                                style={{
                                    paddingTop: "20px",
                                }}
                            >
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{
                                        height: "40px",
                                        width: "120px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{ width: "22px", height: "22px" }}
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    }
                                >
                                    {isEditMode ? 'Update' : 'Submit'}
                                </Button>

                                <Button
                                    type="primary"
                                    onClick={onCancel}
                                    style={{
                                        height: "40px",
                                        width: "120px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "red",
                                        color: "white",
                                        border: "none",
                                    }}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{ width: "22px", height: "22px" }}
                                        >
                                            <path fillRule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
                                        </svg>
                                    }
                                >
                                    Cancel
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>

                </div>
            </div>
        </div>
    );
};

export default SpBank;
